import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useSocket } from "@/context/SocketContext";

const NotifCtx = createContext(null);

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  const socket = useSocket();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const { data } = await api.get("/notifications");
      setItems(data.items || []);
      setUnread(data.unread || 0);
    } catch {}
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!socket) return;
    const off = socket.on((msg) => {
      // Any event except pong refreshes counter
      if (!msg?.event || msg.event === "pong" || msg.event === "connected") return;
      refresh();
    });
    return off;
  }, [socket, refresh]);

  async function markAllRead() {
    try {
      await api.post("/notifications/read");
      setUnread(0);
      setItems((arr) => arr.map((i) => ({ ...i, read: true })));
    } catch {}
  }

  return (
    <NotifCtx.Provider value={{ items, unread, refresh, markAllRead }}>
      {children}
    </NotifCtx.Provider>
  );
}

export function useNotifications() {
  return useContext(NotifCtx);
}
